module.exports = __webpack_public_path__ + "img/mehdi-pro.0c4bd15c.jpg";